import { DaysType } from 'app/constants/configuration/daysType'

export const getDaysType = (type: number): DaysType => {
  let daysType = DaysType.Day1

  switch (type) {
    case 2:
      daysType = DaysType.Day2
      break
    case 3:
      daysType = DaysType.Day3
      break
    case 4:
      daysType = DaysType.Day4
      break
    case 5:
      daysType = DaysType.Day5
      break
    case 6:
      daysType = DaysType.Day6
      break
    case 7:
      daysType = DaysType.Day7
      break
    case 8:
      daysType = DaysType.Day8
      break
    case 9:
      daysType = DaysType.Day9
      break
    case 10:
      daysType = DaysType.Day10
      break
    case 11:
      daysType = DaysType.Day11
      break
    case 12:
      daysType = DaysType.Day12
      break
    case 13:
      daysType = DaysType.Day13
      break
    case 14:
      daysType = DaysType.Day14
      break
    case 15:
      daysType = DaysType.Day15
      break
    case 16:
      daysType = DaysType.Day16
      break
    case 17:
      daysType = DaysType.Day17
      break
    case 18:
      daysType = DaysType.Day18
      break
    case 19:
      daysType = DaysType.Day19
      break
    case 20:
      daysType = DaysType.Day20
      break
    case 21:
      daysType = DaysType.Day21
      break
    case 22:
      daysType = DaysType.Day22
      break
    case 23:
      daysType = DaysType.Day23
      break
    case 24:
      daysType = DaysType.Day24
      break
    case 25:
      daysType = DaysType.Day25
      break
    case 26:
      daysType = DaysType.Day26
      break
    case 27:
      daysType = DaysType.Day27
      break
    case 28:
      daysType = DaysType.Day28
      break
    case 29:
      daysType = DaysType.Day29
      break
    case 30:
      daysType = DaysType.Day30
      break
    case 31:
      daysType = DaysType.LastDay
      break
    case 32:
      daysType = DaysType.DelegationEnd
      break
    case 33:
      daysType = DaysType.DelegationCalculationDate
      break
    case 34:
      daysType = DaysType.CurrentDate
      break
  }

  return daysType
}
